module.exports = __webpack_public_path__ + "img/h5banner_2026.c23ada58.jpg";